export const environment = {
  apiUrl: 'http://localhost:5002/api/',
  externalAdminAuth: true
};
